module.exports = __webpack_public_path__ + "dd133339220d8ee2ba4d0c2b832e1519.png";